import '../vendor/prism';

$(() => {
  var docs = $('#swagger-docs');
  if(docs.length == 0) return;
  import(/* webpackChunkName: "swaggerui" */ 'swagger-ui').then(({ default: SwaggerUI }) => {

    const ui = SwaggerUI({
      url: docs.data("url"),
      domNode: docs[0],
      docExpansion: "full",
      deepLinking: false,
      defaultModelsExpandDepth: -1,
      onComplete: () => {
        var apikey = docs.data("api-key");
        if(apikey) {
          ui.preauthorizeApiKey("APIKeyHeader", apikey)
        }
      }
    })
  });
})
